import React from 'react';
import {Switch, Redirect} from 'react-router-dom';

import Collection from './components/Customers';
import Object from './components/Customer';

import ErrorBoundaryRoute from '../../../../containers/ErrorBoundaryRoute';

export default ({match, locations, roles}) => (
	<div>
		<Switch>
			<ErrorBoundaryRoute exact path={`${match.url}`}>
				<Collection locations={locations}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute path={`${match.url}/:id`}>
				<Object locations={locations} baseUrl={`${match.url}`} roles={roles}/>
			</ErrorBoundaryRoute>

			<ErrorBoundaryRoute>
				<Redirect to={`${match.url}`}/>
			</ErrorBoundaryRoute>
		</Switch>
	</div>
);
